export default "__VITE_ASSET__13170375__"